import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';

var useMedia = function useMedia(query) {
  var _useState = useState(window.matchMedia(query).matches),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(query);

    var onChange = function onChange(e) {
      return setMatches(e.matches);
    };

    mediaQueryList.addEventListener('change', onChange);
    return function () {
      mediaQueryList.removeEventListener('change', onChange);
    };
  }, [query]);
  return matches;
};

export { useMedia };